import script from "./upload-file.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-file.vue?vue&type=script&setup=true&lang=js"

import "./upload-file.vue?vue&type=style&index=0&id=fdabc396&lang=scss"

const __exports__ = script;

export default __exports__